import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './meal-type.reducer';

export const MealTypeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const mealTypeEntity = useAppSelector(state => state.mealType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="mealTypeDetailsHeading">
          <Translate contentKey="activitiesApp.mealType.detail.title">MealType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{mealTypeEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="activitiesApp.mealType.active">Active</Translate>
            </span>
          </dt>
          <dd>{mealTypeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="mealTypeCode">
              <Translate contentKey="activitiesApp.mealType.mealTypeCode">Meal Type Code</Translate>
            </span>
          </dt>
          <dd>{mealTypeEntity.mealTypeCode}</dd>
          <dt>
            <span id="mealTypeName">
              <Translate contentKey="activitiesApp.mealType.mealTypeName">Meal Type Name</Translate>
            </span>
          </dt>
          <dd>{mealTypeEntity.mealTypeName}</dd>
          <dt>
            <span id="createdDate">
              <Translate contentKey="activitiesApp.mealType.createdDate">Created Date</Translate>
            </span>
          </dt>
          <dd>
            {mealTypeEntity.createdDate ? <TextFormat value={mealTypeEntity.createdDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="modifiedDate">
              <Translate contentKey="activitiesApp.mealType.modifiedDate">Modified Date</Translate>
            </span>
          </dt>
          <dd>
            {mealTypeEntity.modifiedDate ? <TextFormat value={mealTypeEntity.modifiedDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
        </dl>
        <Button tag={Link} to="/meal-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/meal-type/${mealTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MealTypeDetail;
